meedy.directive('meedyMask', ['$parse',
    function($parse) {
        var definition = {
            restrict: 'E',
            scope: {
                diameter: '@?',
                value: '='
            },
            templateUrl: 'meedy/application/directive/meedyMask/template/meedy-mask.html',
            link: function($scope, element, attr) {
                $scope._diameter = $scope.diameter ? $scope.diameter : 200;
            }
        };

        return definition;
    }
]);